var map = {
	"./externalBarn_0.png": 1296,
	"./externalBarn_1.png": 1297,
	"./externalBarn_10.png": 1298,
	"./externalBarn_11.png": 1299,
	"./externalBarn_12.png": 1300,
	"./externalBarn_13.png": 1301,
	"./externalBarn_14.png": 1302,
	"./externalBarn_15.png": 1303,
	"./externalBarn_16.png": 1304,
	"./externalBarn_17.png": 1305,
	"./externalBarn_2.png": 1306,
	"./externalBarn_3.png": 1307,
	"./externalBarn_4.png": 1308,
	"./externalBarn_5.png": 1309,
	"./externalBarn_6.png": 1310,
	"./externalBarn_7.png": 1311,
	"./externalBarn_8.png": 1312,
	"./externalBarn_9.png": 1313
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1295;


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/barn ^\.\/externalBarn_.*\.png$
// module id = 1295
// module chunks = 3